import React from 'react';
import { PrivacyPolicyContainer } from '../PrivacyPolicy/PrivacyStyles.styles';

const Termination = () => {
  return (
    <PrivacyPolicyContainer>
      <h3>Termination</h3>
      <p>
        We reserve the right to suspend or terminate your account at our sole
        discretion if you:
      </p>
      <ul>
        <li>Violate these Terms & Conditions or any applicable laws.</li>
        <li>Engage in fraudulent, unlawful, or abusive activities.</li>
        <li>
          Misuse the platform, such as sharing login credentials or altering
          certificates.
        </li>
      </ul>
      <p>
        You may terminate your account at any time by contacting us at{' '}
        <a href="mailto:yodasafetyservices1@outlook.com">
          yodasafetyservices1@outlook.com
        </a>{' '}
        or through your account settings.
      </p>
      <h4>Consequences of Termination</h4>
      <p>Upon termination of your account:</p>
      <ul>
        <li>
          You will lose access to the training portal, courses, quizzes, and
          other services.
        </li>
        <li>
          No refunds will be issued for unused services unless otherwise stated
          in our Refund Policy.
        </li>
        <li>
          We may retain certain information as required by law or for legitimate
          business purposes.
        </li>
      </ul>
      <h4>Data Retention</h4>
      <p>
        After account termination, we may retain your personal information for
        legal, regulatory, or security purposes. If you wish to request the
        deletion of your data, please contact us at{' '}
        <a href="mailto:yodasafetyservices1@outlook.com">
          yodasafetyservices1@outlook.com
        </a>
        .
      </p>
    </PrivacyPolicyContainer>
  );
};

export default Termination;
